(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hyv-color-drop"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function lum(hex) {
      if (!hex) return 0.5;
      var c = hex.replace('#', '');
      if (c.length === 3) c = c[0]+c[0]+c[1]+c[1]+c[2]+c[2];
      var r = parseInt(c.substr(0,2),16), g = parseInt(c.substr(2,2),16), b = parseInt(c.substr(4,2),16);
      return (0.299*r + 0.587*g + 0.114*b) / 255;
    }
    function init(root) {
      var tiles = root.querySelectorAll('.hyv-drop__tile');
      var pills = root.querySelectorAll('[data-fam]');
      tiles.forEach(function (t) {
        if (lum(t.getAttribute('data-hex')) > 0.62) t.classList.add('is-light');
      });
      pills.forEach(function (p) {
        p.addEventListener('click', function () {
          var fam = p.getAttribute('data-fam');
          tiles.forEach(function (t) {
            var match = (fam === '*' || t.getAttribute('data-family') === fam);
            t.classList.toggle('is-hidden', !match);
          });
          pills.forEach(function (q) {
            var on = q === p;
            q.classList.toggle('is-active', on);
            q.setAttribute('aria-selected', on ? 'true' : 'false');
          });
        });
      });
    }
    document.querySelectorAll('[data-hyv-drop]').forEach(init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hyv-find-your-bottle"] && !Shopify.designMode) return;
  try {
    
(function(){
  var HEX = {
    "Midnight Black":"#000000","Arctic White":"#FFFFFF","Charcoal Grey":"#747171","Platinum Grey":"#b4b4b4",
    "Stone Haze":"#bdbcbc","Mirror Chrome":"#d8dbde","Cashmere Beige":"#EAD8AB","Indigo Blue":"#2a588c",
    "Sapphire Blue":"#005BD3","Cobalt Blue":"#005BD3","Glacier Blue":"#8eb4e6","Ocean Blue":"#133C71",
    "Crystal Aqua":"#02d8e9","Cool Mint":"#7cbad1","Sage Green":"#757c49","Forrest Green":"#25743F",
    "Spear Mint":"#80ca75","Matcha Mist":"#a3edb6","Powder Pink":"#FFC0CB","Coral Pink":"#e07d8e",
    "Electric Pink":"#ff65de","Candy Floss":"#FDA5F0","Dusty Rose":"#C47E7E","Pink Marshmallow":"#F4E1E4",
    "Berry Cream":"#EDD7F4","Royal Lavender":"#aa61d1","Serene Lavender":"#e6e6fa","Misty Lilac":"#c8a2c8",
    "Purple Haze":"#ba89d1","Grape Soda":"#9410D5","Sunset Orange":"#FF8A00","Mocha Mint":"#593B17"
  };
  var TIERS = ["compact","standard","large","xl"];
  var QUESTIONS = [
    { key:"use", title:"What's it mainly for?", hint:"Pick the closest match.", type:"single", options:[
      {v:"water", e:"\uD83D\uDCA7", t:"All-day hydration", d:"Plain water, on repeat"},
      {v:"coffee_tea", e:"\u2615", t:"Coffee & tea", d:"Hot drinks that stay hot"},
      {v:"gym", e:"\uD83C\uDFCB\uFE0F", t:"Gym & workouts", d:"High volume, quick sips"},
      {v:"office", e:"\uD83D\uDCBC", t:"Office & desk", d:"Tidy, meeting-friendly"},
      {v:"travel", e:"\uD83E\uDDF3", t:"Travel & commute", d:"Bag, car, on the move"} ]},
    { key:"capacity", title:"How much do you want to carry?", hint:"Bigger holds more but weighs more.", type:"single", options:[
      {v:"compact", e:"\uD83E\uDD64", t:"Compact", d:"A mug — up to 600ml"},
      {v:"standard", e:"\uD83E\uDDF4", t:"Everyday", d:"750ml – 1 litre"},
      {v:"large", e:"\uD83E\uDEA3", t:"Big", d:"1.2 litre tumbler"},
      {v:"xl", e:"\uD83D\uDED2", t:"Max", d:"2 litres, full day"} ]},
    { key:"sip", title:"How do you like to drink?", hint:"The lid style.", type:"single", options:[
      {v:"straw", e:"\uD83E\uDD62", t:"Straw", d:"Sip without tilting"},
      {v:"chug", e:"\uD83C\uDF0A", t:"Chug", d:"Wide mouth, big gulps"},
      {v:"sipper", e:"\uD83D\uDCA7", t:"Sipper", d:"Narrow spout"},
      {v:"versatile", e:"\uD83D\uDD01", t:"Mix it up", d:"Both, depending on the day"} ]},
    { key:"features", title:"Any must-haves?", hint:"Choose as many as you like — or none.", type:"multi", options:[
      {v:"hot", e:"\uD83D\uDD25", t:"Keeps drinks hot too", d:"For coffee & tea"},
      {v:"magsafe", e:"\uD83E\uDDF2", t:"Magnetic / MagSafe", d:"Snaps to phone setups"},
      {v:"handle", e:"\uD83E\uDD1D", t:"Carry handle", d:"Easy to grab"},
      {v:"boot", e:"\uD83D\uDEDF", t:"Drop protection (boot)", d:"Silicone base, survives knocks"},
      {v:"bis", e:"\uD83D\uDEE1\uFE0F", t:"BIS-certified / premium", d:"Top build quality"},
      {v:"cupholder", e:"\uD83D\uDE97", t:"Fits my cup holder", d:"Slim base"} ]}
  ];
  var USE_LABEL = {water:"all-day hydration",coffee_tea:"hot drinks",gym:"the gym",office:"the desk",travel:"travel"};
  var FEAT_LABEL = {hot:"keeps drinks hot",magsafe:"MagSafe",handle:"a carry handle",bis:"BIS-certified build",cupholder:"a cup-holder fit",boot:"a protective silicone boot"};

  function inr(n){ try { return Number(n).toLocaleString('en-IN'); } catch(e){ return n; } }
  function has(arr,v){ return Array.isArray(arr) && arr.indexOf(v) !== -1; }

  function initFinder(root){
    if(!root || root.__hfInit) return; root.__hfInit = true;
    var dataEl = root.querySelector('.hyv-finder-data');
    var stage = root.querySelector('[data-stage]');
    var products = [];
    try { products = JSON.parse(dataEl.textContent); } catch(e){ products = []; }
    var heading = root.getAttribute('data-heading') || "Find your HYV.";
    var intro = root.getAttribute('data-intro') || "Answer four quick questions and we'll match you to the right bottle — in a colour that's in stock.";
    var colorsUrl = root.getAttribute('data-colors-url') || "/pages/color-drop";
    var answers = {}; var step = -1;

    function scoreOf(p){
      if(!p.colors || !p.colors.length) return {s:-Infinity, base:-Infinity, reasons:[]};
      var s = 0; var reasons = [];
      if(answers.use && has(p.use, answers.use)){ s += 3; reasons.push("use"); }
      if(answers.use === "coffee_tea" && !has(p.features,"hot")) s -= 6;
      if(answers.capacity){
        var di = Math.abs(TIERS.indexOf(p.capacity) - TIERS.indexOf(answers.capacity));
        if(di === 0){ s += 3; reasons.push("size"); } else if(di === 1){ s += 1; }
      }
      if(answers.sip){
        if(has(p.sip, answers.sip)){ s += 2; reasons.push("sip"); }
        else if(has(p.sip,"versatile") && (answers.sip==="chug"||answers.sip==="sipper")){ s += 2; reasons.push("sip"); }
        else if(answers.sip==="versatile" && (has(p.sip,"versatile") || (p.sip&&p.sip.length>1))){ s += 2; reasons.push("sip"); }
      }
      (answers.features||[]).forEach(function(f){ if(has(p.features,f)){ s += 2; reasons.push(f); } });
      var base = s;
      s += (p.boost||0) * 0.3;                          // B: push priority / heavy stock
      s += Math.min((p.colors||[]).length,8) * 0.04;    // B: gentle nudge to better-stocked breadth + tie-break
      return {s:s, base:base, reasons:reasons};
    }

    function whyText(p, reasons){
      var bits = [];
      if(reasons.indexOf("size")!==-1) bits.push("the size you wanted");
      if(reasons.indexOf("sip")!==-1) bits.push("your sip style");
      if(answers.use && has(p.use,answers.use)) bits.push("built for "+(USE_LABEL[answers.use]||answers.use));
      (answers.features||[]).forEach(function(f){ if(has(p.features,f)) bits.push(FEAT_LABEL[f]); });
      if(!bits.length) return "The closest fit from what's currently in stock.";
      return "Matched on "+bits.slice(0,3).join(", ")+".";
    }

    function swatches(cols){
      return (cols||[]).map(function(c){
        return '<span class="hf-swatch" title="'+c+'" style="background:'+(HEX[c]||'#cccccc')+'"></span>';
      }).join("");
    }

    function render(){
      if(step === -1) return intro_();
      if(step >= QUESTIONS.length) return results_();
      question_();
    }

    function intro_(){
      stage.innerHTML =
        '<div class="hyv-finder__pad hf-center">'+
          '<div class="hf-eyebrow">The 60-second fit finder</div>'+
          '<h1 class="hf-h1">'+heading+'</h1>'+
          '<p class="hf-lede">'+intro+'</p>'+
          '<div style="margin-top:28px"><button class="hf-btn" data-start>Start &rarr;</button></div>'+
        '</div>';
      stage.querySelector('[data-start]').onclick = function(){ step = 0; render(); };
    }

    function question_(){
      var q = QUESTIONS[step]; var sel = answers[q.key];
      var dots = QUESTIONS.map(function(_,i){ return '<span class="'+(i<=step?'on':'')+'"></span>'; }).join("");
      var opts = q.options.map(function(o){
        var on = q.type==="multi" ? (sel||[]).indexOf(o.v)!==-1 : sel===o.v;
        return '<button class="hf-opt'+(on?' sel':'')+'" data-v="'+o.v+'">'+
          '<span class="hf-emoji">'+o.e+'</span>'+
          '<span><span class="hf-ot">'+o.t+'</span><br><span class="hf-od">'+o.d+'</span></span>'+
          '<span class="hf-check">'+(on?'\u2713':'')+'</span></button>';
      }).join("");
      stage.innerHTML =
        '<div class="hyv-finder__pad">'+
          '<div class="hf-progress">'+dots+'</div>'+
          '<div class="hf-qnum">Question '+(step+1)+' of '+QUESTIONS.length+'</div>'+
          '<h3 class="hf-h2">'+q.title+'</h3>'+
          '<p class="hf-hint">'+q.hint+'</p>'+
          '<div class="hf-opts">'+opts+'</div>'+
          '<div class="hf-nav">'+
            '<button class="hf-link" data-back>'+(step===0?'':'&larr; Back')+'</button>'+
            '<button class="hf-btn" data-next style="'+(q.type==='single'?'display:none':'')+'">'+(step===QUESTIONS.length-1?'See my match':'Next')+' &rarr;</button>'+
          '</div>'+
        '</div>';
      Array.prototype.forEach.call(stage.querySelectorAll('.hf-opt'), function(b){
        b.onclick = function(){
          var v = b.getAttribute('data-v');
          if(q.type==="multi"){
            var arr = answers[q.key] ? answers[q.key].slice() : [];
            var i = arr.indexOf(v); if(i>=0) arr.splice(i,1); else arr.push(v);
            answers[q.key] = arr; question_();
          } else {
            answers[q.key] = v; setTimeout(function(){ step++; render(); }, 150);
          }
        };
      });
      var back = stage.querySelector('[data-back]'); if(back) back.onclick = function(){ if(step>0){ step--; render(); } };
      var next = stage.querySelector('[data-next]'); if(next) next.onclick = function(){ step++; render(); };
    }

    function results_(){
      var ranked = products.map(function(p){ var r = scoreOf(p); return {p:p, s:r.s, base:r.base, reasons:r.reasons}; })
        .filter(function(x){ return x.s > -Infinity; })
        .sort(function(a,b){ if(b.s!==a.s) return b.s - a.s; return (b.p.colors||[]).length - (a.p.colors||[]).length; });

      if(!ranked.length){
        stage.innerHTML = '<div class="hyv-finder__pad hf-center"><h3 class="hf-h2">Hmm, nothing in stock right now.</h3>'+
          '<p class="hf-lede">Everything in that combination is sold out. <a href="/collections/shop-all">Browse all bottles &rarr;</a></p>'+
          '<div style="margin-top:24px"><button class="hf-btn ghost" data-again>Start over</button></div></div>';
        stage.querySelector('[data-again]').onclick = function(){ answers={}; step=-1; render(); };
        return;
      }

      var best = ranked[0];
      var strong = best.base >= 5;
      var alts = ranked.slice(1,3);

      var altHtml = alts.map(function(a){
        return '<a class="hf-alt" href="'+a.p.url+'">'+
          '<span class="hf-ai"><img src="'+a.p.img+'" alt="'+a.p.label+'" loading="lazy"></span>'+
          '<span><span class="hf-an">HYV '+a.p.label+'</span><br>'+
          '<span class="hf-ad">'+(a.p.colors||[]).length+' colours in stock</span>'+
          '<span class="hf-ap">\u20B9'+inr(a.p.price)+'</span></span></a>';
      }).join("");

      stage.innerHTML =
        '<div class="hyv-finder__pad">'+
          '<div class="hf-center"><div class="hf-eyebrow">'+(strong?'Your match':'Closest we\u2019ve got')+'</div>'+
          '<h3 class="hf-h2">'+(strong?'Meet your HYV.':'Not a perfect fit \u2014 but the closest in stock.')+'</h3></div>'+
          '<div class="hf-match">'+
            '<div class="hf-ph"><img src="'+best.p.img+'" alt="'+best.p.label+'"></div>'+
            '<div class="hf-info">'+
              '<span class="hf-badge'+(strong?'':' soft')+'">'+(strong?'Best match':'Closest match')+'</span>'+
              '<h3 class="hf-h3">HYV '+best.p.label+'</h3>'+
              '<p class="hf-why">'+whyText(best.p, best.reasons)+'</p>'+
              '<div class="hf-price">\u20B9'+inr(best.p.price)+'</div>'+
              '<div class="hf-sw">'+swatches(best.p.colors)+'</div>'+
              '<div class="hf-row">'+
                '<a class="hf-btn" href="'+best.p.url+'">Shop '+best.p.label+' &rarr;</a>'+
                '<a class="hf-btn ghost" href="'+colorsUrl+'">See all colours</a>'+
              '</div>'+
            '</div>'+
          '</div>'+
          (alts.length ? '<div class="hf-alts"><h4>You might also consider</h4><div class="hf-altgrid">'+altHtml+'</div></div>' : '')+
          '<div class="hf-nav" style="justify-content:center;margin-top:28px"><button class="hf-btn ghost" data-again>Start over</button></div>'+
        '</div>';
      stage.querySelector('[data-again]').onclick = function(){ answers={}; step=-1; render(); };
    }

    render();
  }

  function initAll(){ Array.prototype.forEach.call(document.querySelectorAll('[data-finder]'), initFinder); }
  if(document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function(e){
    var el = e.target.querySelector('[data-finder]'); if(el){ el.__hfInit=false; initFinder(el); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
